import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {LoginComponent} from './login/login.component';
import {NewListComponent} from './new-list/new-list.component';
import {ListOverviewComponent} from './list-overview/list-overview.component';
import {ShoppingListComponent} from './shopping-list/shopping-list.component';
import {IngredientsListComponent} from './ingredients/ingredients-list/ingredients-list.component';
import {AuthGuard} from './auth/auth.guard';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'new-list',
    component: NewListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'lists',
    component: ListOverviewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'lists/:id',
    component: ShoppingListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'ingredients',
    component: IngredientsListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: '',
    redirectTo: 'lists',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
